<script setup lang="ts">
import { Categories, NearbyStores } from '@/components/browse';
import LandingFooter from '@/components/landing/LandingFooter.vue';

definePageMeta({
  layout: 'browse',
  auth: false,
});

useHead({
  title: 'Marketplace',
});

const config = useRuntimeConfig();
const baseURL = config.public.baseURL;
const title = 'Tradel | Marketplace';
const description =
  'Tradel is an Australian-owned, on-demand delivery platform built for trade, construction, and retail.';
const image = baseURL + '/logo.png';

useSeoMeta({
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage: image,
  twitterTitle: title,
  twitterDescription: description,
  twitterImage: image,
  twitterCard: 'summary',
});

const { isMobile } = useScreenSize();
</script>

<template>
  <div class="marketplace-page">
    <div class="marketplace-content">
      <v-container fluid class="browse-max-screen-size">
        <div class="d-flex" :class="[isMobile ? 'flex-column-reverse' : 'flex-column']">
          <Categories :is-mobile="isMobile" />
          <NearbyStores :is-mobile="isMobile" />
        </div>
      </v-container>
    </div>

    <LandingFooter />
  </div>
</template>

<style lang="scss" scoped>
.marketplace-page {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 64px);

  .marketplace-content {
    flex-grow: 1;
  }
}

.browse-max-screen-size {
  max-width: calc(1152px + 16px * 2) !important;
}
</style>
